import React from 'react';
import Button from '../Button/Button';
import { ButtonSize, ButtonType, ButtonVariant } from '../Button/Button.type';
import Icon from '../Icon/Icon';
import { IconSize, IconStyle } from '../Icon/Icon.type';
import { FloatingPanelType } from './FloatingPanel.type';
import classNames from 'classnames';

const FloatingPanelHeader = ({
  icon,
  title,
  expanded,
  type,
  onToggleExpand,
  onPanelClose,
}) => {
  const headerIconClass = classNames(
    'DS__floating-panel__header-icon',
    {
      'DS__floating-panel__header-icon--destructive': type === FloatingPanelType.DESTRUCTIVE,
      'DS__floating-panel__header-icon--standard': type === FloatingPanelType.STANDARD,
    }
  )
  return (
    <div className='DS__floating-panel__header'>
      <div>
          <div className={headerIconClass}>
            {icon}
          </div>
          <div>
            {title}
          </div>
      </div>

      <div>
          <Button
              dataTestId="floating-panel-expand-btn"
              type={ButtonType.GHOST_ICON}
              size={ButtonSize.small}
              variant={ButtonVariant.NEUTRAL}
              text={<Icon name={expanded ? 'minimize' : 'maximize'} size={IconSize.SMALL} style={IconStyle.OUTLINED} color="$grey50" />}
              tooltipText={expanded ? 'Minimise' : 'Maximise'}
              onClick={onToggleExpand}
          />
          <Button
              dataTestId="floating-panel-close-btn"
              type={ButtonType.GHOST_ICON}
              size={ButtonSize.small}
              variant={ButtonVariant.NEUTRAL}
              text={<Icon name="chevron-down" size={IconSize.SMALL} style={IconStyle.OUTLINED} color="$grey50" />}
              tooltipText="Collapse"
              onClick={onPanelClose}
          />
      </div>
    </div>
  )
};

export default FloatingPanelHeader;